module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-supply-chain-hero-lowres.49ccc1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-supply-chain-hero-lowres.jpg
// module id = C/bh
// module chunks = 0